/* LISTA DE MENSAJES DE ERROR */
export const errorMessages = [
    "Lo sentimos, estamos teniendo problemas. Por favor, ponte en contacto con nuestro equipo de soporte para obtener ayuda.",
    "No se puede iniciar sesión. Verifique sus credenciales antes de continuar.",
    "Anteriormente se solicitó una nueva clave de acceso. Comuníquese con el equipo de TI para obtener más información.",
    "El usuario está temporalmente inactivo. Comuníquese con el equipo de TI para obtener más información.",
    "Su sesión ha expirado. Por favor, vuelva a iniciar sesión para continuar.",
    "No hay datos disponibles para mostrar en este momento.",
];
